var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg31(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7b829d",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 216 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.2,102.9c-4.6,11-17.2,16.1-28.2,11.5c-11-4.6-16.1-17.2-11.5-28.2c4.6-11,17.2-16.1,28.2-11.5 C116.7,79.3,121.8,91.9,117.2,102.9C117.2,102.9,117.2,102.9,117.2,102.9z M213.9,154.6c0,4.3-3.5,7.8-7.8,7.8c0,0,0,0,0,0h-12.7 v26.8c0,20.8-16.9,37.7-37.7,37.7c0,0,0,0,0,0h-15V254h-102v-81.1C-2.8,140.2-10,80.1,22.6,38.5C40.7,15.5,68.4,2,97.7,2 c43.4,0,83.4,32.6,91.7,68.4c1.9,8,4,28.8,4,28.8l19.9,52.4C213.7,152.5,213.9,153.5,213.9,154.6L213.9,154.6z M138.2,87.8l12.2-7.6 l-5.1-12.5l-14.1,3.2c-2.7-3.8-6-7.2-9.8-9.9l3.3-14l-12.5-5.2l-7.7,12.2c-4.6-0.8-9.4-0.8-14-0.1L83,41.5l-12.6,5.1l3.2,14 c-3.8,2.7-7.2,6-9.9,9.8l-14-3.3l-5.3,12.5l12.2,7.7c-0.8,4.6-0.8,9.4-0.1,14L44.3,109l5.1,12.5l14-3.2c2.7,3.8,6,7.2,9.8,9.9 l-3.3,14l12.5,5.2l7.7-12.2c4.6,0.8,9.4,0.8,14,0.1l7.6,12.2l12.5-5.1l-3.2-14.1c3.8-2.7,7.2-6,9.9-9.8l14,3.3l5.2-12.5l-12.2-7.7 C139,97.1,139,92.4,138.2,87.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/31.9c072305eca111960f6a13c7b21ed4a8.svg";
export { ForwardRef as ReactComponent };